import { defineStore } from 'pinia';
import websocketApi from '@/apis/system/socketAPI';
import IndexedDB from '@/commons/indexedDB';
import { useContextStore } from '@/stores/context';
import commonFunction from '@/commons/commonFunction';
import { getCurrentInstance } from 'vue';
import { io } from 'socket.io-client';
import popupUtil from '@/commons/popupUtil.js';
import { ref } from 'vue';
import { MSConstant } from '@/commons/wildcards';
import { useNotificationStore } from '@/stores/other/notificationStore';
import callbackFileCheckAPI from '@/apis/other/callbackFileCheckAPI.js';
import WebSocketStatusCode from '@/commons/wildcards/constants/WebSocketStatusCode';
import { useReportSummaryStore } from '@/stores/report/reportSummaryStore';
import { useToast } from 'vue-toast-notification';
// Thêm import cần thiết
import { MD5 } from 'crypto-js';
import dashboardCacheConfig from '@/cache/config/dashboardCacheConfig.js';
import { enumCacheLevel } from '@/cache/cacheEnum.js'; // Thêm import enumCacheLevel
import eventBusGlobal from '@/commons/eventBusGlobal.js';
import { MSEventName } from '@/commons/eventName.js';

const DEFAULTEXPIREDSECOND = 900; // Giống trong useChartData

export const useWebsocketStore = defineStore('websocketStore', {
  state: () => {
    return {
      mapSession: {},
      mapTimeInterval: {},
      connectedSocket: false,
      sessionId: null,
      exports: [],
      retryItems: [],
      // Thêm tracking cho các luồng giao dự toán
      deliveryProcessTracking: {}, // { processId: { typeDeliver, deliveryStreams: {...} } }
    };
  },
  actions: {
    sendNotificationEnactDic: async data => {
      let res = JSON.parse(data);
      if (
        (res.Code =
          MSConstant.WebSocketStatusCode.Success &&
          res.Data.Ids.find(x => x == useContextStore().Context.OrganizationID))
      ) {
        const formatDate = date => {
          const day = String(date.getDate()).padStart(2, '0');
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const year = String(date.getFullYear());
          const hours = String(date.getHours()).padStart(2, '0');
          const minutes = String(date.getMinutes()).padStart(2, '0');
          const seconds = String(date.getSeconds()).padStart(2, '0');

          return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
        };
        let enact = [
          {
            value: formatDate(new Date(res.Data.Date)),
          },
        ];
        const notificationStore = useNotificationStore();
        await notificationStore.pushNotification(null, res);
        popupUtil.show('NotificationSyncDictionaryPopup', {enact_date: enact});
      }
    },

    /**
     * Thông báo bắn về
     * @param {*} sender
     * @param {*} res
     */
    websocketGlobalNotification: data => {
      let res = JSON.parse(data);
      if (
        (res.Code =
          MSConstant.WebSocketStatusCode.Success &&
          res.Data.Ids.find(x => x == useContextStore().Context.OrganizationID))
      ) {
        const notificationStore = useNotificationStore();
        notificationStore.pushNotification(null, res);
      }
    },
    /**
     * Thông báo gửi phản hồi/biên bản kiểm tra xuống cấp dưới
     * @param {*} data
     * PTTAM2 20/05/2024
     */
    sendBackNotificationEstimateToInferior: data => {
      let res = JSON.parse(data);
      if (
        (res.Code =
          MSConstant.WebSocketStatusCode.Success &&
          res.Data.OrganizationID === useContextStore().Context.OrganizationID)
      ) {
        let param = res.Data;
        popupUtil.show('EstimateSubmitRecNotifySuperiorPopup', param);
      }
    },

    /**
     * Thông báo gửi phản hồi/biên bản kiểm tra xuống cấp dưới đầu năm
     * @param {*} data
     * nmtuan4 13/05/2025
     */
    sendBackNotificationInitial: data => {
      let res = JSON.parse(data);
      if (
        (res.Code =
          MSConstant.WebSocketStatusCode.Success &&
          res.Data.OrganizationID === useContextStore().Context.OrganizationID)
      ) {
        let param = res.Data;
        popupUtil.show('EstimateSubmitInitialNotifyPopup', param);
      }
    },

    /**
     * Thông báo gửi phản hồi/biên bản kiểm tra dự toán 3 năm xuống cấp dưới
     * @param {*} data
     * tvtoan 24/10/2024
     */
    sendBackNotificationEstimateThreeYearToInferior: data => {
      let res = JSON.parse(data);
      if (
        (res.Code =
          MSConstant.WebSocketStatusCode.Success &&
          res.Data.OrganizationID === useContextStore().Context.OrganizationID)
      ) {
        let param = res.Data;
        popupUtil.show('EstimateSubmitThreeYearNotiPopup', param);
      }
    },

    /**
     * Xử lý dữ liệu trạng thái của submit
     * @param {*} data Dữ liệu socket trả ra
     */
    updateProcessState: async function (data) {
      let me = this,
        res = JSON.parse(data);
      if (res.Code === MSConstant.WebSocketStatusCode.Success) {
        const {useProcessManagerStore} = await import('@/stores/process/processManagerStore.js');
        const processStore = useProcessManagerStore();
        let process = processStore.items.find(x => x.id === res.Data.id);
        if (process) {
          process.status = res.Data.status;
          process.successRecord = res.Data?.successRecord || 0;
          process.totalRecord = res.Data?.totalRecord || 0;
          process.falseRecord = res.Data?.falseRecord || 0;
          process.orgs = res.Data?.orgs || [];
          process.index = res.Data?.index || 0;
        }

        me.customUpdateProcessState(res.Data, process);
      }
    },

    /**
     * Xử lý dữ liệu trạng thái của giao dự toán (bổ sung/điều chỉnh)
     * @param {*} data Dữ liệu socket trả ra
     */
    updateDelAddAdjProcessState: async function (data) {
      let me = this,
        res = JSON.parse(data);

      if (res.Code === MSConstant.WebSocketStatusCode.Success) {
        const {useProcessManagerStore} = await import('@/stores/process/processManagerStore.js');
        const processStore = useProcessManagerStore();
        let process = processStore.items.find(x => x.id === res.Data.id);

        if (!process) return; // Không tìm thấy process

        const processId = res.Data.id;
        const typeDeliver = res.Data.typeDeliver;

        // Xử lý theo loại giao dự toán
        if (typeDeliver === 1 || typeDeliver === 2) {
          // Luồng đơn - xử lý như cũ
          me.updateProcessDirectly(process, res.Data);
        } else if (typeDeliver === 3) {
          // Cả 2 luồng - cần tracking
          me.handleDualStreamDelivery(processId, process, res.Data);
        }
      }
    },

    /**
     * Cập nhật process trực tiếp (logic cũ)
     */
    updateProcessDirectly: function (process, data) {
      process.status = data.status;
      process.successRecord = data?.successRecord || 0;
      process.totalRecord = data?.totalRecord || 0;
      process.falseRecord = data?.falseRecord || 0;
      process.orgs = data?.orgs || [];
      process.index = data?.index || 0;
    },

    /**
     * Xử lý tracking cho 2 luồng song song
     */
    handleDualStreamDelivery: function (processId, process, data) {
      const me = this;

      // Khởi tạo tracking nếu chưa có
      if (!me.deliveryProcessTracking[processId]) {
        me.deliveryProcessTracking[processId] = {
          typeDeliver: 3,
          deliveryStreams: {},
          process: process,
          timeout: null,
        };

        // Thiết lập timeout để tránh chờ vô hạn (30 giây)
        me.deliveryProcessTracking[processId].timeout = setTimeout(() => {
          console.log(`Process ${processId}: Timeout waiting for delivery streams`);
          me.cleanupDeliveryTracking(processId);
        }, 70000);
      }

      const tracking = me.deliveryProcessTracking[processId];

      // Xác định loại luồng dựa trên dữ liệu trả về
      const streamType = me.identifyStreamType(data);

      // Lưu kết quả của luồng
      tracking.deliveryStreams[streamType] = {
        status: data.status,
        successRecord: data?.successRecord || 0,
        totalRecord: data?.totalRecord || 0,
        falseRecord: data?.falseRecord || 0,
        orgs: data?.orgs || [],
        index: data?.index || 0,
        completed: true,
        timestamp: new Date(),
      };

      // Kiểm tra xem cả 2 luồng đã hoàn thành chưa
      const streamTypes = Object.keys(tracking.deliveryStreams);
      const hasAdditionStream = streamTypes.includes('addition');
      const hasAdjustmentStream = streamTypes.includes('adjustment');

      if (hasAdditionStream && hasAdjustmentStream) {
        // Cả 2 luồng đã hoàn thành
        me.processDualStreamResults(processId, tracking);
      }
    },

    /**
     * Xác định loại luồng (bổ sung hoặc điều chỉnh)
     * Cần backend bổ sung trường phân biệt hoặc dùng pattern khác
     */
    identifyStreamType: function (data) {
      // Backend cần bổ sung trường để phân biệt luồng bổ sung vs điều chỉnh
      // Có thể dựa vào:
      // - data.deliveryType (1: bổ sung, 2: điều chỉnh)
      // - data.streamId
      // - data.processType

      // Tạm thời sử dụng logic dựa trên deliveryType nếu có
      if (data.deliveryType === 1) {
        return 'addition'; // Giao bổ sung
      } else if (data.deliveryType === 2) {
        return 'adjustment'; // Giao điều chỉnh
      }

      // Fallback - có thể dùng timestamp hoặc order để phân biệt
      // Hoặc có thể dùng một trường khác từ backend
      const currentTime = new Date().getTime();
      return currentTime % 2 === 0 ? 'addition' : 'adjustment';
    },

    /**
     * Xử lý kết quả khi cả 2 luồng hoàn thành
     */
    processDualStreamResults: function (processId, tracking) {
      const me = this;
      const {deliveryStreams, process} = tracking;

      const additionResult = deliveryStreams.addition;
      const adjustmentResult = deliveryStreams.adjustment;

      // Kiểm tra cả 2 luồng đều thành công
      const additionSuccess = me.isStreamSuccessful(additionResult);
      const adjustmentSuccess = me.isStreamSuccessful(adjustmentResult);

      if (additionSuccess && adjustmentSuccess) {
        // Cả 2 luồng thành công - cập nhật process
        const combinedResult = me.combineStreamResults(additionResult, adjustmentResult);
        me.updateProcessDirectly(process, combinedResult);

        console.log(`Process ${processId}: Both streams completed successfully`);
      } else {
        // Có luồng thất bại - giữ nguyên trạng thái hoặc cập nhật lỗi
        console.warn(`Process ${processId}: One or both streams failed`, {
          addition: additionSuccess,
          adjustment: adjustmentSuccess,
        });

        // Có thể cập nhật trạng thái lỗi hoặc giữ nguyên
        // process.status = MSConstant.ProcessStatus.Error; // hoặc giá trị phù hợp
      }

      // Cleanup tracking
      me.cleanupDeliveryTracking(processId);
    },

    /**
     * Kiểm tra luồng có thành công không
     */
    isStreamSuccessful: function (streamResult) {
      // Điều kiện thành công có thể là status = 2 (hoàn thành) hoặc tương tự
      // Cần điều chỉnh theo constant của project
      return streamResult.status === 2 || streamResult.status === MSConstant.ProcessStatus?.Success;
    },

    /**
     * Kết hợp kết quả từ 2 luồng
     */
    combineStreamResults: function (additionResult, adjustmentResult) {
      return {
        status: MSConstant.ProcessStatus.Success,
        successRecord: (additionResult.successRecord || 0) + (adjustmentResult.successRecord || 0),
        totalRecord: (additionResult.totalRecord || 0) + (adjustmentResult.totalRecord || 0),
        falseRecord: (additionResult.falseRecord || 0) + (adjustmentResult.falseRecord || 0),
        orgs: [...(additionResult.orgs || []), ...(adjustmentResult.orgs || [])],
        index: Math.max(additionResult.index || 0, adjustmentResult.index || 0),
      };
    },

    /**
     * Cleanup tracking data
     */
    cleanupDeliveryTracking: function (processId) {
      const tracking = this.deliveryProcessTracking[processId];
      if (tracking && tracking.timeout) {
        clearTimeout(tracking.timeout);
      }
      delete this.deliveryProcessTracking[processId];
    },

    /**
     * @param {*} data Dữ liệu socket trả ra
     */
    observeMovementBatchError: async function (data) {
      let me = this,
        res = JSON.parse(data);
      if (res.Code === MSConstant.WebSocketStatusCode.Error) {
        const {useProcessManagerStore} = await import('@/stores/process/processManagerStore.js');
        const processStore = useProcessManagerStore();
        let process = processStore.items.find(x => x.message_type === MSConstant.MessageType.ObserverMovementSentData);
        if (process) {
          process.status = res.Data.status;
          process.successRecord = res.Data?.successRecord || 0;
          process.totalRecord = res.Data?.totalRecord || 0;
          process.falseRecord = res.Data?.falseRecord || 0;
          process.orgs = res.Data?.orgs || [];
          process.index = res.Data?.index || 0;
        }
      }
    },

    /**
     * @param {*} data Dữ liệu socket trả ra
     */
    observeMovementBatchComplete: async function (data) {
      let me = this,
        res = JSON.parse(data);
      if (res.Code === MSConstant.WebSocketStatusCode.Success) {
        const {useProcessManagerStore} = await import('@/stores/process/processManagerStore.js');
        const {useImplementationTrackingCQSNStore} = await import(
          '@/stores/implementationTracking/implementationTrackingCQSNStore.js'
        );
        const {useDbOptionStore} = await import('@/stores/dbOption/dbOptionStore');

        const dbOptionStore = useDbOptionStore();
        const pageSize = ref(dbOptionStore.data.RecordsPerPage || 20);
        const pageSkip = ref(0);

        const processStore = useProcessManagerStore();
        const storeImplementationTracking = useImplementationTrackingCQSNStore();

        let process = processStore.items.find(x => x.message_type === MSConstant.MessageType.ObserverMovementSentData);
        if (process) {
          process.status = res.Data.status;
          process.successRecord = res.Data?.successRecord || 0;
          process.totalRecord = res.Data?.totalRecord || 0;
          process.falseRecord = res.Data?.falseRecord || 0;
          process.orgs = res.Data?.orgs || [];
          process.index = res.Data?.index || 0;
        }

        await storeImplementationTracking.getData({
          api: '/movement-organization-state',
          pageSkip: pageSkip.value,
          pageSize: pageSize.value,
        });
      }
    },

    /**
     * Custom update
     * @param {*} process
     * @returns
     */
    customUpdateProcessState: function (newData, process) {
      if (!newData) return;

      switch (`newData`.message_type) {
        case MSConstant.MessageType.ReportSummary:
          if (process) {
            process.report_summary_message = newData.report_summary_message;
          }

          //Gửi cập nhật trạng thái của process trước khi được tạo mới - case khó xảy ra
          if (newData && !process) {
            this.retryItems.push(newData);
          }

          //Cập nhật vào store lưu trữ
          //Báo cáo tùy chỉnh
          let reportSummaryStore = useReportSummaryStore();
          reportSummaryStore.report = newData;

          break;
        default:
          break;
      }
    },

    /**
     * Thêm mới process
     * @param {*} data Dữ liệu socket trả ra
     */
    createProcessItem: async function (data) {
      let me = this,
        res = JSON.parse(data);
      if (res.Code === MSConstant.WebSocketStatusCode.Success) {
        const {useProcessManagerStore} = await import('@/stores/process/processManagerStore.js');
        const processStore = useProcessManagerStore();
        if (res.Data.id && !processStore.items.find(x => x.id === res.Data.id)) {
          processStore.items.unshift(res.Data);
        }

        me.customCreateProcessItem(res.Data, processStore.items);
      }
    },

    /**
     *
     * @param {*} process
     * @returns
     */
    customCreateProcessItem: function (data, processes) {
      if (!data) return;

      switch (data.message_type) {
        case MSConstant.MessageType.ReportSummary:
          //Kiểm tra đã gửi cập nhật về chưa
          var retryItem = this.retryItems.find(x => x.id === data.id);
          if (!retryItem) break;

          //Cập nhật lại trạng thái của process
          let process = processes.find(x => x.id === retryItem.id);
          process.status = retryItem.status;
          process.report_summary_message = retryItem.report_summary_message;

          //Remove
          this.retryItems = this.retryItems.filter(x => x.id !== data.id);
          break;
        default:
          break;
      }
    },

    /**
     * Load trạng thái giao dự toán
     * @param {*} data
     * tvanh 11.02.2025
     */
    updateAllocationDeliverStatus: async function (data) {
      let res = JSON.parse(data);
      if (res.Code === MSConstant.WebSocketStatusCode.Success) {
        const {useAllocationDeliverPtcListStore} = await import(
          '@/stores/allocationDeliver/allocationDeliverPtcListStore'
        );
        const store = useAllocationDeliverPtcListStore();
        store.getList();
        const organizationPackCodeType = ref(useContextStore().Context.OrganizationPackCodeType);
        //Nếu là DVCQ
        if (organizationPackCodeType.value == MSConstant.OrganizationPackCodeType.ChuQuanSuNghiep) {
          const {useAllocationDeliverSCQListStore} = await import(
            '@/stores/allocationDeliver/allocationDeliverSCQListStore'
          );
          const storeSCQ = useAllocationDeliverSCQListStore();
          storeSCQ.getList();
        } else if (organizationPackCodeType.value == MSConstant.OrganizationPackCodeType.STC) {
          // Xử lí cho STC
          const {useAllocationDeliverListStore} = await import('@/stores/allocationDeliver/allocationDeliverListStore');
          const storeSTC = useAllocationDeliverListStore();
          storeSTC.getList();
        }

        if (res.Data.countSuccess > 0) {
          const alcImp = res.Data.alcImp;
          store.backupAlcImp({
            AlcImpId: commonFunction.generateUUID(),
            OldAlcImpId: alcImp.alc_imp_id,
            Status: MSConstant.AllocationImplementStatus.Backup,
            AlcImpName: alcImp.alc_imp_id,
            AlcImpType: alcImp.alc_imp_type,
            AllocationDate: alcImp.allocation_date,
            AlcSupId: alcImp.alc_sup_id,
            AlcSupId: alcImp.alc_sup_id,
            isCheckUnitDetail: alcImp.is_check_unit_detail || false,
          });
        }
      }
    },

    /**
     * Load trạng thái bổ sung phân bổ
     * @param {*} data
     */
    updateAlcAddDelStatus: async function (data) {
      let res = JSON.parse(data);
      if (res.Code === MSConstant.WebSocketStatusCode.Success) {
        const organizationPackCodeType = ref(useContextStore().Context.OrganizationPackCodeType);
        // Nếu là DVCQ
        if (organizationPackCodeType.value == MSConstant.OrganizationPackCodeType.ChuQuanSuNghiep) {
          const {useAllocationDeliverSCQListStore} = await import(
            '@/stores/allocationDeliver/allocationDeliverSCQListStore'
          );
          const storeSCQ = useAllocationDeliverSCQListStore();
          storeSCQ.getList();
        }
      }
    },

    updateAuditState: async function (data) {
      let res = JSON.parse(data);
      if ((res.Code = MSConstant.WebSocketStatusCode.Success)) {
        const {useExamineListStore} = await import('@/stores/examine/examineListStore.js');
        const {useExamineListFormStore} = await import('@/stores/examine/examineListFormStore');

        const $toast = useToast(window._toastConfig || {});
        const store = useExamineListStore();
        const storeExamine = useExamineListFormStore();
        let record = store.items.find(x => x.organization_child_id == res.Data.organization_child_id);
        let recordList = storeExamine.items.find(x => x.audit_estimate_list_id == res.Data.audit_estimate_list_id);
        if (
          res.Data.status != MSConstant.ExamineStatus.ProcessReturn &&
          res.Data.status != MSConstant.ExamineStatus.ProcessComplete &&
          (record || recordList)
        ) {
          if (record) {
            record.examine_status = res.Data.status;
            record.sync_status = res.Data.sync_status;
            if (res.Data.status == MSConstant.ExamineStatus.Return) {
              record.sent_status = 0;
            } else {
              record.sent_status = 5;
            }
          }

          if (recordList) {
            recordList.status = res.Data.status;
          }

          // switch (res.Data.status) {
          //   case MSConstant.ExamineStatus.FailReturn:
          //     $toast.warning('Đã xảy ra lỗi trong quá trình gửi trả. Vui lòng thử lại.');
          //     record.needs_examine_status = MSConstant.NeedsExamineStatus.FailReturn;

          //     break;
          //   case MSConstant.ExamineStatus.FailComplete:
          //     $toast.warning('Đã xảy ra lỗi trong quá trình hoàn thành kiểm tra. Vui lòng thử lại.');
          //     record.needs_examine_status = MSConstant.NeedsExamineStatus.FailComplete;

          //     break;
          //   case MSConstant.ExamineStatus.Return:
          //     $toast.success('Gửi trả thành công.');
          //     break;
          //   case MSConstant.ExamineStatus.Complete:
          //     $toast.success('Hoàn thành kiểm tra thành công.');
          //     break;
          //   case MSConstant.ExamineStatus.Checking:
          //     if(res.Data.pre_status == MSConstant.ExamineStatus.Complete){
          //       $toast.success('Hủy hoàn thành kiểm tra thành công.');
          //     }
          //     break;
          //   default: break;
          // }
          // clearTimeout(this.exports[res.Data.organization_child_id]);
          // delete this.exports[res.Data.organization_child_id];
        }
      }
    },

    /**
     * Cập nhật trạng thái kiểm tra đầu năm
     * @param {*} data
     */
    updateAuditStateInitial: async function (data) {
      let res = JSON.parse(data);
      if (res.Code === MSConstant.WebSocketStatusCode.Success) {
        const {useExamineInitialListStore} = await import('@/stores/estInitial/examineInitialListStore');
        const {useAuditEstimateInitialListStore} = await import(
          '@/stores/auditInitial/auditEstimateInitialListStore.js'
        );

        const $toast = useToast(window._toastConfig || {});
        const store = useExamineInitialListStore();
        const storeExamine = useAuditEstimateInitialListStore();
        let record = store.items.find(x => x.organization_child_id == res.Data.organization_child_id);
        let recordList = storeExamine.items.find(
          x => x.audit_est_initial_list_id == res.Data.audit_est_initial_list_id,
        );
        if (
          res.Data.status != MSConstant.ExamineStatus.ProcessReturn &&
          res.Data.status != MSConstant.ExamineStatus.ProcessComplete &&
          (record || recordList)
        ) {
          if (record) {
            record.examine_status = res.Data.status;
            record.sync_status = res.Data.sync_status;
            if (res.Data.status == MSConstant.ExamineStatus.Return) {
              record.sent_status = 0;
            } else {
              record.sent_status = 5;
            }
          }

          if (recordList) {
            recordList.status = res.Data.status;
          }
        }
      }
    },

    /**
     * Xử lý dữ liệu trạng thái của submit
     * @param {*} data Dữ liệu socket trả ra
     */
    updateSubmitEstimateListState: async function (data) {
      let res = JSON.parse(data);
      if ((res.Code = MSConstant.WebSocketStatusCode.Success)) {
        let store = {};
        switch (res.Data.message_type) {
          case MSConstant.MessageType.SentEstimate:
            const {useSubmitEstimateStore} = await import('@/stores/submit/submitEstimateStore.js');
            store = useSubmitEstimateStore();
            break;
          case MSConstant.MessageType.SentEstimateSectorWide:
          case MSConstant.MessageType.CancelCompleteArrgrate:
            const {useSubmitSectorWideStore} = await import(
              '@/stores/submitSectorWide/submitEstimateSectorWideStore.js'
            );
            store = useSubmitSectorWideStore();
            break;
          case MSConstant.MessageType.SentEstimateArrgrate:
          case MSConstant.MessageType.CancelCompletePTC:
            const {useSubmitArrgrateStore} = await import(
              '@/stores/submit/submitArrgrate/submitEstimateArrgrateStore.js'
            );
            store = useSubmitArrgrateStore();
            break;
          default:
            store.items = [];
            break;
        }

        const $toast = useToast(window._toastConfig || {});
        let record = store.items.find(x => x.submit_estimate_list_id == res.Data.submit_estimate_list_id);
        if (record) {
          record.status = res.Data.status;
          record.sync_status = res.Data.sync_status;
        }
      }
    },

    /**
     * Xử lý dữ liệu trạng thái của submit
     * @param {*} data Dữ liệu socket trả ra
     */
    updateSDNSSubmitEstimateListState: async function (data) {
      let res = JSON.parse(data);
      if ((res.Code = MSConstant.WebSocketStatusCode.Success)) {
        let store = {};
        switch (res.Data.message_type) {
          case MSConstant.MessageType.SDNSSentEstimate:
            const {useSubmitEstimateInitialStore} = await import('@/stores/estInitial/submitEstimateInitialStore.js');
            store = useSubmitEstimateInitialStore();
            break;
          default:
            store.items = [];
            break;
        }

        const $toast = useToast(window._toastConfig || {});
        let record = store.items.find(x => x.submit_est_initial_id == res.Data.submit_est_initial_id);
        if (record) {
          record.status = res.Data.status;
          record.sync_status = res.Data.sync_status;
        }
      }
    },

    /**
     * Thông báo gửi phản hồi/biên bản kiểm tra xuống cấp dưới
     * @param {*} data
     * PTTAM2 20/05/2024
     */
    'websocket-export'(res) {
      let data = JSON.parse(res);
      let context = useContextStore();
      if (!data) {
        return;
      }
      const {Data} = data;
      if (Data && Data.ClientId == context.BumasClientId) {
        clearTimeout(this.exports[Data.ExportId]);
        delete this.exports[Data.ExportId];
        if (data.Code == WebSocketStatusCode.Success) {
          const link = callbackFileCheckAPI.getFileLink(MSConstant.StorageFileType.Temp, Data.FileName, Data.Name);
          commonFunction.downloadLink(link);
        }
        commonFunction.unmask();
      }
    },
    /**
     * Thông báo bắn về
     * @param {*} sender
     * @param {*} res
     */
    websocketLogout: data => {
      let res = JSON.parse(data);
      if (!res) return;
      const {Data} = res;
      if (!Data) return;
      const {databaseId, organizationId, tenantId, userId} = Data;
      const context = useContextStore();
      const contextData = context.Context;
      const {DatabaseId, TenantId, UserId, OrganizationID} = contextData;
      if (databaseId == DatabaseId && organizationId == OrganizationID && tenantId == TenantId && userId == UserId) {
        context.logout();
      }
    },

    /**
     * Cập nhật dữ liệu cache cho biểu đồ từ WebSocket message
     * @param {string} data Dữ liệu JSON string từ socket
     */
    async updateChartDataCache(data) {
      try {
        if (!data) return;

        const socketMessage = JSON.parse(data);
        if (!socketMessage || !socketMessage.Data) {
          console.warn('WebSocket: Dữ liệu chart không hợp lệ', socketMessage);
          return;
        }

        const chartEventData = socketMessage.Data;
        let {dashboard_type, param_key, chart_data, request_param, is_re_call_api, dashboard_param} = chartEventData;
        if (is_re_call_api === true) {
          chart_data = [];
        }

        if (!dashboard_type || !param_key || !chart_data) {
          console.warn('WebSocket: Thiếu thông tin cần thiết trong dữ liệu chart', chartEventData);
          return;
        }

        // 1. Lấy cấu hình cache dựa trên dashboard_type
        let enumDashboardTypeName = commonFunction.getEnumText(dashboard_type, 'DashboardType');
        let keyCacheConfigName = 'Das_' + enumDashboardTypeName;
        let cacheConfigDefinition = dashboardCacheConfig[keyCacheConfigName];

        if (!cacheConfigDefinition) {
          commonFunction.errorLogging(`Chưa cấu hình cache config cho Dashboard type: ${dashboard_type}`);
        } else {
          // 2. Tạo cache key động - sử dụng param_key trực tiếp từ WebSocket
          let keyCache = cacheConfigDefinition.KeyFormat.replace('{dashboard_type}', dashboard_type);
          keyCache = keyCache.replace('{param_key}', param_key);
          let expiredInSecond = cacheConfigDefinition.ExpireTimeoutInSecond || DEFAULTEXPIREDSECOND;

          const finalCacheConfig = {
            KeyCache: keyCache,
            ExpiredInSecond: expiredInSecond,
            CacheLevel: cacheConfigDefinition.CacheLevel || enumCacheLevel.CacheIndexDB,
          };

          // 3. Lưu vào Cache dựa trên CacheLevel
          let expiredDate = new Date();
          expiredDate.setSeconds(expiredDate.getSeconds() + finalCacheConfig.ExpiredInSecond);

          // Chuẩn bị dữ liệu dashboard để lưu vào cache
          const newDashboardObject = {
            data: chart_data,
            payload: request_param || {}, // Sử dụng request_param nếu có, nếu không thì dùng object rỗng
            expired: expiredDate.getTime(),
          };

          // Lưu cache vào localStorage hoặc IndexedDB tùy theo cấu hình
          if (finalCacheConfig.CacheLevel === enumCacheLevel.CacheLocalStorage) {
            localStorage.setItem(finalCacheConfig.KeyCache, JSON.stringify(newDashboardObject));
            console.log(
              `WebSocket: Đã cập nhật LocalStorage cache cho dashboard ${dashboard_type} với key ${finalCacheConfig.KeyCache}`,
            );
          } else {
            // Mặc định hoặc CacheIndexDB
            const indexDb = new IndexedDB();
            await indexDb.set(finalCacheConfig.KeyCache, newDashboardObject);
            console.log(
              `WebSocket: Đã cập nhật IndexedDB cache cho dashboard ${dashboard_type} với key ${finalCacheConfig.KeyCache}`,
            );
          }
        }

        // 4. Phát sự kiện thông báo có dữ liệu mới để các component có thể cập nhật UI
        eventBusGlobal.$emit(MSEventName.dashboardDataUpdated, {
          dashboard_type: dashboard_type,
          param_key: param_key,
          data: chart_data,
          is_re_call_api: is_re_call_api || false,
          dashboard_param,
        });

        console.log(`WebSocket: Đã phát sự kiện cập nhật dữ liệu cho dashboard ${dashboard_type}`);
      } catch (ex) {
        commonFunction.errorLogging('Lỗi xử lý WebSocket chart data:', ex);
      }
    },

    updateConnectedSocket(sessionId) {
      this.connectedSocket = true;
      this.sessionId = sessionId;
    },
    async connectSocket() {
      const {proxy} = getCurrentInstance();

      if (this.connectedSocket) return;
      const indexDbInstance = new IndexedDB();
      const contextStore = useContextStore();
      const clientId = commonFunction.generateUUID();
      const socketCacheKey = window._socketKeyCache ?? 'socket_config';
      await contextStore.updateSocketClientId(clientId);
      const socketConfig = await indexDbInstance.get(socketCacheKey);

      const getAndSaveConfig = async () => {
        const config = await websocketApi.getConfigAsync(clientId);
        if (config) {
          var now = new Date();
          now.setSeconds(now.getSeconds() + config.TokenExpiredSecond);
          config.TokenExpired = now.getTime();
          indexDbInstance.set(socketCacheKey, config);
          return config;
        }
      };

      const connectSocket = (token, brokerUrl) => {
        const me = this;
        const options = {
          transports: ['websocket'],
          reconnectionDelayMax: 10000,
          query: `token=${token}`,
        };
        const vueSocketIo = proxy.$vueSocketIo;
        if (vueSocketIo) {
          const ioConnection = io(brokerUrl, options);
          ioConnection.on('connect', function () {
            const sessionId = ioConnection.io.engine.id; //
            me.updateConnectedSocket(sessionId);
          });

          ioConnection.on('connect_error', async e => {
            if (e.data && e.data.code === 'invalid_token') {
              if (retryInvalidToken <= retryInvalidTokenMaxCount) {
                retryInvalidToken++;
                const config = await getAndSaveConfig();
                connectSocket(config.Token, config.BrokerUrl);
              }
            }
          });
          vueSocketIo.connect(ioConnection, {});
        }
      };
      if (socketConfig) {
        const {BrokerUrl, Token, TokenExpired} = socketConfig;
        const now = new Date().getTime();

        const isExpired = TokenExpired < now;
        if (!BrokerUrl || !Token || isExpired) {
          const renewConfig = await getAndSaveConfig();
          connectSocket(renewConfig.Token, renewConfig.BrokerUrl);
        } else {
          connectSocket(Token, BrokerUrl);
        }
      } else {
        const renewConfig = await getAndSaveConfig();
        connectSocket(renewConfig.Token, renewConfig.BrokerUrl);
      }
    },
    /**
     * Xử lý tiến trình tải database từ WebSocket
     * @param {string} data Dữ liệu JSON string từ socket
     */
    createDownloadDatabaseProgress: function (data) {
      try {
        const res = JSON.parse(data);

        if (res.Data) {
          const downloadData = res.Data;

          // Emit event để useDownloadData có thể lắng nghe và cập nhật
          eventBusGlobal.$emit(MSEventName.downloadDataUpdated, {
            id: downloadData.id,
            status: downloadData.status,
            created_date: downloadData.created_date,
            end_date: downloadData.end_date,
            created_by: downloadData.created_by,
            budget_year: downloadData.budget_year,
            message: downloadData.message || '',
            progress: downloadData.progress || 0,
            total: downloadData.total || 0,
            timestamp: new Date().getTime(),
          });

          console.log('WebSocket: Cập nhật tiến trình tải database', downloadData);
        } else {
          console.error('WebSocket: Lỗi nhận dữ liệu tiến trình tải database', res);

          // Emit event lỗi
          eventBusGlobal.$emit(MSEventName.downloadDataError, {
            message: res.Message || 'Có lỗi xảy ra khi tải database',
          });
        }
      } catch (error) {
        console.error('WebSocket: Lỗi parse dữ liệu tiến trình tải database', error);

        // Emit event lỗi
        eventBusGlobal.$emit(MSEventName.downloadDataError, {
          message: 'Lỗi xử lý dữ liệu tiến trình',
        });
      }
    },
  },
});
